module.exports = __webpack_public_path__ + "img/favicon.d31def3.png";